import { useState, useEffect, useContext } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import NominaContext from "../context/NominProvider";
const Layout = ({ Auth }) => {
  const { selectedNomina, setSelectedNomina } = useContext(NominaContext);
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);

  return (
    <div className="layout-container">
      <div className="navbar">
        <Navbar
          Auth={Auth}
          selectedNominaId={selectedNomina}
          setSelectedNominaId={setSelectedNomina}
        />
      </div>
      <div className="main-content">
        <Outlet
          context={{
            selectedNomina,
            empleadoSeleccionado,
            setEmpleadoSeleccionado,
          }}
        />
      </div>
    </div>
  );
};

export default Layout;
